import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const SelectWalletCurrenciesFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const currencies = useAppSelector((state) => state.wallet.currencies)
  const data = currencies.map((x) => ({ id: x.id, label: x.id, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Currencies'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
